import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/org/$orgId/attendance")({
	component: AttendanceLayout,
});

function AttendanceLayout() {
	// This is a layout component that renders child routes
	return <Outlet />;
}
